export function getIndexedDBPath(url: string) {
	const regex = /\/indexed_db\/.+$/;
	const match = url.match(regex);
	return match ? match[0] : null;
}
